import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./Hero.css";
import Button from "../Other Components/button"; // Assuming this path is correct

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const Hero = ({
  title,
  subtitle,
  btnText,
  btnStyle,
  image,
  onClick,
  btnText2,
  onClick2,
  badge,
}) => {
  const targetRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start start", "end start"],
  });

  const imageY = useTransform(scrollYProgress, [0, 1], ["0%", "-30%"]);

  return (
    <section className="hero-container" ref={targetRef}>
      <div className="hero-image-wrapper">
        <motion.img
          src={"/Images/" + image}
          alt="Hero Background"
          className="hero-image"
          style={{ y: imageY }}
        />
        <div className="hero-image-overlay"></div>
      </div>

      <div className="hero-orb hero-orb-1" aria-hidden="true"></div>
      <div className="hero-orb hero-orb-2" aria-hidden="true"></div>

      <div className="hero-content">
        <motion.div
          className="hero-text-container"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {badge && (
            <motion.span variants={itemVariants} className="hero-badge">
              {badge}
            </motion.span>
          )}
          <motion.h1 variants={itemVariants} className="hero-title">
            {title}
          </motion.h1>
          <motion.p variants={itemVariants} className="hero-subtitle">
            {subtitle}
          </motion.p>
          <motion.div variants={itemVariants} className="hero-btn-row">
            <Button className={btnStyle} onClick={onClick}>
              {btnText}
            </Button>
            {btnText2 && (
              <Button className="hero-btn secondary" onClick={onClick2}>
                {btnText2}
              </Button>
            )}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
